import styled from 'styled-components';

export const HomeworkBox = styled.div`
  margin: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  @media only screen and (max-width: 600px) {
    display: block;
  }
`;

export const RichTextContent = styled.div`
  font-size: 14px;
  line-height: 1.5;

  p {
    margin-bottom: 1em;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  a {
    color: #3192e4;
    text-decoration: none;
  }

  ul,
  ol {
    margin-left: 2em;
    margin-bottom: 1em;
  }

  li {
    margin-bottom: 0.5em;
  }

  strong {
    font-weight: bold;
  }

  u {
    text-decoration: underline;
  }

  em {
    font-style: italic;
  }

  span[style*='color'] {
    display: inline;
  }

  span[style*='background-color'] {
    display: inline;
    padding: 0 2px;
  }

  blockquote {
    margin: 0 0 1em;
    padding: 0.5em 1em;
    border-left: 3px solid #e8e8e8;
    background-color: #f9f9f9;
  }

  pre {
    max-width: 100%;
    overflow: auto;
    padding: 1em;
    background-color: #f8f8f8;
    border-radius: 3px;
  }
`;

export const EditorContainer = styled.div`
  border: 1px solid rgba(34, 36, 38, 0.15);
  border-radius: 4px;
  margin-bottom: 1em;

  .bf-container {
    border: none;
  }

  .bf-content {
    height: 150px;
    overflow: auto;
  }
`;
